import { Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PageNotfound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/onboarding"); // This will navigate one step back in the history
  };

  return (
    <div style={{display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '90vh',
        textAlign: 'center',
        backgroundColor: '#f0f0f0',} }>
      <Typography style={styles.title}>Page Not Found</Typography>
      <Typography style={styles.goBack} onClick={handleGoBack}>
        GO Back
      </Typography>
    </div>
  );
};

const styles = {

  title: {
    fontSize: '2.5rem',
    marginBottom: '20px',
  },
  goBack: {
    fontSize: '1.2rem',
    color: '#3f51b5',
    cursor: 'pointer',
    marginTop: '10px',
    textDecoration: 'none', 
  },
};

export default PageNotfound;
